import { Component } from '@angular/core';

@Component({
  selector: 'mos-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mos-website';
}
